import { render, staticRenderFns } from "./ChangeContactSales.vue?vue&type=template&id=81b20842&scoped=true"
import script from "./ChangeContactSales.vue?vue&type=script&lang=js"
export * from "./ChangeContactSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b20842",
  null
  
)

export default component.exports